import { render, staticRenderFns } from "./LayoutFull.vue?vue&type=template&id=ca8efb5c&scoped=true"
import script from "./LayoutFull.vue?vue&type=script&lang=js"
export * from "./LayoutFull.vue?vue&type=script&lang=js"
import style0 from "./LayoutFull.vue?vue&type=style&index=0&id=ca8efb5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8efb5c",
  null
  
)

export default component.exports